import { createAction, createReducer } from '@reduxjs/toolkit';
import localStorage from '../../utils/localStorage';
import { types } from '../types';

const accessToken = createAction(types.USERLOGIN_AUTH_SUCCESS);

const initialState = { accessToken: "" };

const Login = createReducer(initialState, (builder) => {
    builder
        .addCase(accessToken, (state, action) => {
            localStorage.set('expiresIn', action.user.ExpiresIn);
            localStorage.set('accessToken', action.user.AccessToken);
            localStorage.set('currentSite', action.user.SiteId);
            state.accessToken = action.user.AccessToken;
        })
        .addDefaultCase(() => { });
});

export default Login;